import { Expose } from "class-transformer";
import { IsNumber } from "class-validator";
import { AddEditContractorCode } from "./AddEditContractorCode";

export class ContractorCode extends AddEditContractorCode {
  @Expose()
  @IsNumber()
  id!: number;

  @Expose()
  @IsNumber()
  recordStampId!: number;
}
